var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.74 7.99954L11.394 16.9995M6.606 16.9995L6.26 7.99954M16.228 4.78954C16.57 4.84154 16.91 4.89654 17.25 4.95554M16.228 4.78954L15.16 18.6725C15.1164 19.2378 14.8611 19.7657 14.445 20.1508C14.029 20.5359 13.4829 20.7497 12.916 20.7495H5.084C4.5171 20.7497 3.97102 20.5359 3.55498 20.1508C3.13894 19.7657 2.88359 19.2378 2.84 18.6725L1.772 4.78954M16.228 4.78954C15.0739 4.61506 13.9138 4.48264 12.75 4.39254M1.772 4.78954C1.43 4.84054 1.09 4.89554 0.75 4.95454M1.772 4.78954C2.92613 4.61506 4.08623 4.48264 5.25 4.39254M12.75 4.39254V3.47654C12.75 2.29654 11.84 1.31254 10.66 1.27554C9.55362 1.24018 8.44638 1.24018 7.34 1.27554C6.16 1.31254 5.25 2.29754 5.25 3.47654V4.39254M12.75 4.39254C10.2537 4.19962 7.74628 4.19962 5.25 4.39254",
    stroke: "#FF3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.12909b232e543edf148d3bf492445f94.svg";
export { ForwardRef as ReactComponent };